// src/components/homeComponents/TrustBar.jsx
import React from "react";

const TrustBar = () => {
  return (
    <section className="trustbar mb-2">
      <div className="trustbar-inner">
        <div className="trustbar-grid">

          <div className="trustbar-card">
            <div className="trustbar-icon">
              <i className="fas fa-shipping-fast"></i>
            </div>
            <div>
              <h5 className="trustbar-title">Entregas locales</h5>
              <p className="trustbar-desc">
                Envíos rápidos en el todo el territorio urbano.
              </p>
            </div>
          </div>

          <div className="trustbar-card">
            <div className="trustbar-icon">
              <i className="fas fa-headset"></i>
            </div>
            <div>
              <h5 className="trustbar-title">Asesoría personalizada</h5>
              <p className="trustbar-desc">
                Atención directa con un asesor.
              </p>
            </div>
          </div>

          <div className="trustbar-card">
            <div className="trustbar-icon">
              <i className="fas fa-undo"></i>
            </div>
            <div>
              <h5 className="trustbar-title">Cambios y garantías</h5>
              <p className="trustbar-desc">
                Política flexible y sin complicaciones.
              </p>
            </div>
          </div>

          <div className="trustbar-card">
            <div className="trustbar-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <div>
              <h5 className="trustbar-title">Calidad en cada prenda</h5>
              <p className="trustbar-desc">
                Productos de alta calidad y buen acabado.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TrustBar;
